import { axiosInstance } from './api';

/** «Очереди и сотрудники» одной панелью (Алексей 22.10, #1798): BE checkout_control/api/queues_staff.py. */
export interface QueueThresholdDto {
  id: number;
  name: string;
  /** Алерт, когда в очереди БОЛЬШЕ этого числа людей. */
  max_allowed_size: number;
}

export interface QueuesStaffSettingsDto {
  queues: QueueThresholdDto[];
  arrival_enabled: boolean;
  /** Что нужно, чтобы включить приход: размеченная зона бара. */
  arrival_requirement: 'staff_polygon' | null;
  arrival_minutes: number;
  arrival_people: number;
  /** Утренние сообщения в чат; выключены — приход только считается. */
  arrival_messages: boolean;
  arrival_chat_id: string | null;
  arrival_thread_id: string | null;
  /** Зона, в которой ждём людей (#2321); null — все рабочие зоны. */
  arrival_area_id: number | null;
  arrival_areas: ArrivalAreaDto[];
}

export interface ArrivalAreaDto {
  id: number;
  name: string;
  kind: 'staff' | 'standalone';
  camera_id: number;
  camera_name: string;
  /** Вершины в долях кадра (PolygonArea.direction_vectors). */
  vectors: number[][];
}

export type QueuesStaffPatch = Partial<Omit<QueuesStaffSettingsDto, 'queues' | 'arrival_requirement' | 'arrival_areas'>> & {
  queues?: { id: number; max_allowed_size: number }[];
};

export const queuesStaffKey = (zoneId: string) => `queues-staff:${zoneId}`;

export const getQueuesStaffSettings = (zoneId: string) =>
  axiosInstance.get<QueuesStaffSettingsDto>(`/checkout_control/queues-staff/${zoneId}/`);

export const patchQueuesStaffSettings = (zoneId: string, payload: QueuesStaffPatch) =>
  axiosInstance.patch<QueuesStaffSettingsDto>(`/checkout_control/queues-staff/${zoneId}/`, payload);
